<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-card elevation="8" class="rounded-lg">
          <v-card-text class="text-center pt-8 pb-4">
            <v-icon size="64" color="primary" class="mb-4">mdi-chat</v-icon>
            <h1 class="text-h4 font-weight-bold mb-1" style="color: #075E54">Yapp</h1>
            <p class="text-body-2 text-grey">Chat WhatsApp - Vivanta Dental</p>
          </v-card-text>

          <v-card-text class="px-8">
            <v-alert
              v-if="error"
              type="error"
              variant="tonal"
              closable
              class="mb-4"
              @click:close="error = null"
            >
              {{ error }}
            </v-alert>

            <v-form @submit.prevent="handleLogin" ref="form">
              <v-text-field
                v-model="username"
                label="Usuario"
                prepend-inner-icon="mdi-account"
                variant="outlined"
                :rules="[v => !!v || 'Usuario requerido']"
                class="mb-2"
              />
              <v-text-field
                v-model="password"
                label="Contraseña"
                prepend-inner-icon="mdi-lock"
                :type="showPassword ? 'text' : 'password'"
                :append-inner-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                @click:append-inner="showPassword = !showPassword"
                variant="outlined"
                :rules="[v => !!v || 'Contraseña requerida']"
                class="mb-4"
              />
              <v-btn
                type="submit"
                color="primary"
                block
                size="large"
                :loading="loading"
                :disabled="!username || !password"
              >
                Iniciar Sesión
              </v-btn>
            </v-form>
          </v-card-text>

          <v-card-text class="text-center pt-0 pb-6">
            <p class="text-caption text-grey">Usa tus credenciales de Vivanta</p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const router = useRouter()
const authStore = useAuthStore()

const username = ref('')
const password = ref('')
const showPassword = ref(false)
const loading = ref(false)
const error = ref(null)

const handleLogin = async () => {
  if (!username.value || !password.value) return

  loading.value = true
  error.value = null

  const result = await authStore.login({
    username: username.value,
    password: password.value
  })

  loading.value = false

  if (result.success) {
    router.push({ name: 'Chat' })
  } else {
    error.value = result.error || 'Error al iniciar sesión'
  }
}
</script>

<style scoped>
.fill-height {
  min-height: 100vh;
  background: linear-gradient(135deg, #075E54 0%, #128C7E 50%, #25D366 100%);
}
</style>
